import template from "./pManagement.html";

export function pManagementDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pManagementController,
    controllerAs: 'pManagement',
    bindToController: true
  };

  return directive;
}

class pManagementController {
  constructor(Auth, Management, $q, DownloadFile, $location, $scope, $interval, Notes, ConnectionQuality, Sort) {
    'ngInject';

    this.Auth = Auth;
    this.Sort = Sort;

    this.init();
    this.Management = Management;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$q = $q;
    this.$scope = $scope;
    this.DownloadFile = DownloadFile;
    this.$location = $location;

    this.downloadDisabled = true;

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        if (this.user.role == 'Employee') {
          this.$location.path('/');
        }
        this.Management.getAvailableSelections().then(
          (success) => {
            this.countries = [];
            success.data.availableCountries.forEach((c, i) => {
              this.countries[i] = {
                name: c
              };
            });
            this.countries.sort(this.compare);
            this.countriesDisplay = angular.fromJson(angular.toJson(this.countries));
            this.sites = success.data.availableSites.filter( site => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : site.name != "Iterators HQ").sort(this.compare);
            this.sitesDisplay = angular.fromJson(angular.toJson(this.sites));
            this.profitCenters = success.data.availableProfitCenters.sort(this.compare);
            this.profitCentersDisplay = angular.fromJson(angular.toJson(this.profitCenters));
            this.teamsArchived = success.data.availableTeams.filter(team => team.archivedAt || team.sites.length == 0).sort(this.Sort.abcBy("name"));
            this.teamsActual = success.data.availableTeams.filter(team => !team.archivedAt && team.sites.length != 0).sort(this.Sort.abcBy("name"));
            this.teams = this.teamsActual.sort(this.compare).concat(this.teamsArchived)
              .map(t => ({
                ...t,
                noSites: t.sites.length == 0,
                noProfitCenter: t.profitCenterId == undefined
              }))
              .filter(team => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.name != "Team Iterators");
            this.teamsDisplay = angular.fromJson(angular.toJson(this.teams));
            this.serviceLines = [];
            success.data.availableServiceLines.forEach((s, i) => {
              this.serviceLines[i] = {
                name: s
              };
            });

            this.serviceLines.sort(this.compare);
            this.serviceLines.forEach((s, i) => {
              var countriesForServiceLine = [];
              this.teams.forEach(t => {
                if (t.serviceLine == s.name && !countriesForServiceLine.find(c => c.country == t.country)) {
                  countriesForServiceLine = countriesForServiceLine.concat(t);
                }
              });
              countriesForServiceLine.forEach((t, i) => countriesForServiceLine[i] = t.country);
              this.serviceLines[i].countries = [].concat(countriesForServiceLine);
            });
            this.serviceLinesDisplay = angular.fromJson(angular.toJson(this.serviceLines));

            if (this.user.role == 'GlobalManager') {
              this.teamsVisibility = false;
            } else {
              this.teamsVisibility = true;
            }

            if (this.user.role == 'CountryManager') {
              this.countriesDisplay.forEach(c => c.selected = true);
              this.profitCentersDisplay.forEach(p => p.selected = true);
            } else if (this.user.role == 'SiteManager') {
              this.countriesDisplay.forEach(c => c.selected = true);
              this.profitCentersDisplay.forEach(p => p.selected = true);
              this.sitesDisplay.forEach(s => s.selected = true);
            } else if (this.user.role == 'ServiceLineManager' || this.user.role == 'SiteServiceLineManager') {
              this.countriesDisplay.forEach(c => c.selected = true);
              this.profitCentersDisplay.forEach(p => p.selected = true);
              this.sitesDisplay.forEach(s => s.selected = true);
              this.serviceLinesDisplay.forEach(s => s.selected = true);
            } else if (this.user.role == 'TeamLeader' || this.user.role == 'DeputyTeamLeader') {
              this.countriesDisplay.forEach(c => c.selected = true);
              this.profitCentersDisplay.forEach(p => p.selected = true);
              this.sitesDisplay.forEach(s => s.selected = true);
              this.serviceLinesDisplay.forEach(s => s.selected = true);
              this.teamsDisplay.forEach(t => t.selected = true);
            }

            this.state = 'loaded';
            this.$scope.$apply();
          },
          () => {
            this.state = 'error';
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }

    return 0;
  }

  compareSites(a, b) {
    if (a.sites.length > b.sites.length) {
      return -1;
    }
    if (a.sites.length < b.sites.length) {
      return 1;
    }
    return 0;
  }

  resetData() {
    this.selectedTeams = this.teams.filter(({selected}) => selected);
    if (this.user.role == 'GlobalManager') {
      if (this.countriesDisplay.find(c => c.selected == true)) {
        this.teamsVisibility = true;
      } else {
        this.teamsVisibility = false;
      }
    }

    this.teamsDisplay = this.teams.filter(t => {
      if ((this.countriesDisplay.find(c => c.selected == true) ? this.countriesDisplay.find(c => c.selected && c.name == t.country) : this.countriesDisplay.find(c => c.name == t.country))
      && (this.serviceLinesDisplay.find(s => s.selected == true) ? this.serviceLinesDisplay.find(s => s.selected && s.name == t.serviceLine) : this.serviceLinesDisplay.find(s => s.name == t.serviceLine))
      && (this.sitesDisplay.find(s => s.selected == true) ? (t.sites.find(s => this.sitesDisplay.find(site => site.selected && site.id == s)) || t.sites.length === 0) : true)
      && (this.profitCentersDisplay.find(p => p.selected == true) ? (this.profitCentersDisplay.find(p => p.selected && p.id == t.profitCenterId) || t.profitCenterId == undefined) : true)
    ) {
        return t;
      } else {
        return null;
      }
    });

    if (this.allCountriesSelected && this.countriesDisplay.find(c => c.selected != true)) {
      this.allCountriesSelected = false;
    }
    if (!this.allCountriesSelected && this.countriesDisplay.every(c => c.selected == true)) {
      this.allCountriesSelected = true;
    }

    if (this.allSitesSelected && this.sitesDisplay.find(s => s.selected != true)) {
      this.allSitesSelected = false;
    }
    if (!this.allSitesSelected && this.sitesDisplay.every(s => s.selected == true)) {
      this.allSitesSelected = true;
    }

    if (this.allProfitCentersSelected && this.profitCentersDisplay.find(p => p.selected != true)) {
      this.allProfitCentersSelected = false;
    }
    if (!this.allProfitCentersSelected && this.profitCentersDisplay.every(p => p.selected == true)) {
      this.allProfitCentersSelected = true;
    }

    if (this.allServiceLinesSelected && this.serviceLinesDisplay.find(s => s.selected != true)) {
      this.allServiceLinesSelected = false;
    }
    if (!this.allServiceLinesSelected && this.serviceLinesDisplay.every(s => s.selected == true)) {
      this.allServiceLinesSelected = true;
    }

    if (this.allTeamsSelected && this.teamsDisplay.find(t => t.selected != true)) {
      this.allTeamsSelected = false;
    }
    if (!this.allTeamsSelected && this.teamsDisplay.every(t => t.selected == true)) {
      this.allTeamsSelected = true;
    }

  }

  filterSites() {
    if (this.countriesDisplay.filter(c => c.selected).length > 0) {
      this.sitesDisplay = [];
      this.countriesDisplay.filter(c => c.selected).forEach(c => {
        this.sitesDisplay = this.sitesDisplay.concat(this.sites.filter(s => s.country == c.name));
      });
    } else {
      this.sitesDisplay = this.sites;
    }
  }

  filterProfitCenters() {
    if (this.countriesDisplay.filter(c => c.selected).length > 0) {
      this.profitCentersDisplay = [];
      this.countriesDisplay.filter(c => c.selected).forEach(c => {
        this.profitCentersDisplay = this.profitCentersDisplay.concat(this.profitCenters.filter(p => p.country == c.name));
      });
    } else {
      this.profitCentersDisplay = this.profitCenters;
    }
  }

  filterServiceLines() {
    if (this.countriesDisplay.filter(c => c.selected).length > 0) {
      this.serviceLinesDisplay = [];
      this.countriesDisplay.filter(c => c.selected).forEach(c => {
        this.serviceLinesDisplay = this.serviceLinesDisplay.concat(this.serviceLines.filter(s => {
          if (s.countries && !this.serviceLinesDisplay.find(sld => sld == s)) {
            return s.countries.find(country => country == c.name);
          } else {
            return null;
          }
        }));
      });
    } else {
      this.serviceLinesDisplay = this.serviceLines;
    }
  }

  updateDownloadAvailability() {
    if (this.dateEndChoice && this.dateStartChoice && this.teamsDisplay.find(t => t.selected)) {
      this.downloadDisabled = false;
    } else {
      this.downloadDisabled = true;
    }
  }

  download() {
    this.state = 'loading';
    var teams = [];
    this.teamsDisplay.forEach(t => {
      if (t.selected) {
        teams = teams.concat(t.id);
      }
    });
    this.Management.getManagementReport(this.dateStartChoice, this.dateEndChoice, teams).then(
      (success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers("content-type"),
          `management-report_${this.dateStartChoice}_${this.dateEndChoice}.xlsx`
          );

          this.state = 'loaded';
      },
      () => {
        this.state = 'error';
      }
    );
  }

  selectAllCountries() {
    this.countriesDisplay.forEach(c => {
      if (this.allCountriesSelected) {
        c.selected = true;
      } else {
        c.selected = false;
      }
    });

    this.filterSites();
    this.filterProfitCenters();
    this.filterServiceLines();
    this.resetData();
  }

  selectAllSites() {
    this.sitesDisplay.forEach(s => {
      if (this.allSitesSelected) {
        s.selected = true;
      } else {
        s.selected = false;
      }
    });
  }

  selectAllProfitCenters() {
    this.profitCentersDisplay.forEach(p => {
      if (this.allProfitCentersSelected) {
        p.selected = true;
      } else {
        p.selected = false;
      }
    });
  }

  selectAllServiceLines() {
    this.serviceLinesDisplay.forEach(s => {
      if (this.allServiceLinesSelected) {
        s.selected = true;
      } else {
        s.selected = false;
      }
    });
  }

  selectAllTeams() {
    this.teamsDisplay.forEach(t => {
      if (this.allTeamsSelected) {
        t.selected = true;
      } else {
        t.selected = false;
      }
    });
  }
}
